/* DYA Editorial V2. Progressive visual enhancements; native commerce is untouched. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const prepared = new WeakSet();
  const wired = new WeakSet();
  let observer;
  let frame = 0;
  const targets = '.dya-section-heading, .dya-product-grid__item, .dya-editorial__item, .dya-look__copy, .dya-brand-note__copy, .dya-services > h2, .dya-service, .dya-v2-footer .footer-community';

  function prepareMotion(scope = document) {
    if (reduced.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
      document.documentElement.classList.remove('dya-motion-ready');
      document.querySelectorAll('.dya-reveal').forEach(el => el.classList.add('is-visible'));
      observer?.disconnect();
      return;
    }
    document.documentElement.classList.add('dya-motion-ready');
    observer ||= new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }, {threshold: .08, rootMargin: '0px 0px -24px 0px'});
    scope.querySelectorAll(targets).forEach(el => {
      if (prepared.has(el)) return;
      prepared.add(el);
      el.classList.add('dya-reveal');
      const index = Array.from(el.parentElement.children).indexOf(el);
      el.style.setProperty('--dya-reveal-delay', `${(index % 4) * 35}ms`);
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight - 24 && rect.bottom > 0) el.classList.add('is-visible');
      else observer.observe(el);
    });
  }

  function prepareMarquee(scope = document) {
    scope.querySelectorAll('.dya-announcement-marquee').forEach(shell => {
      const button = shell.querySelector('.dya-announcement-marquee__toggle');
      if (!button || wired.has(button)) return;
      wired.add(button);
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = button.getAttribute('aria-pressed') !== 'true';
        shell.classList.toggle('is-paused', paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Putar running text' : 'Jeda running text');
        button.querySelector('span').textContent = paused ? '▷' : 'Ⅱ';
      });
    });
  }

  function progress() {
    frame = 0;
    const root = document.documentElement;
    const header = document.querySelector('#header-component');
    if (!header) return;
    if (!header.querySelector('.dya-reading-progress')) {
      const line = document.createElement('span');
      line.className = 'dya-reading-progress';
      line.setAttribute('aria-hidden', 'true');
      header.append(line);
    }
    const length = root.scrollHeight - root.clientHeight;
    header.style.setProperty('--dya-page-progress', String(length > 0 ? Math.min(1, Math.max(0, root.scrollTop / length)) : 0));
    header.classList.toggle('dya-is-scrolled', root.scrollTop > 25);
  }
  function queueProgress() { if (!frame) frame = requestAnimationFrame(progress); }
  function initialize(scope = document) { prepareMarquee(scope); prepareMotion(scope); queueProgress(); }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:reorder', queueProgress);
  document.addEventListener('shopify:section:unload', () => { observer?.disconnect(); observer = undefined; document.querySelectorAll('.dya-reveal').forEach(el => el.classList.add('is-visible')); queueProgress(); });
  reduced.addEventListener('change', () => prepareMotion());
  window.addEventListener('scroll', queueProgress, {passive: true});
  window.addEventListener('resize', queueProgress, {passive: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
})();
